export default "__VITE_ASSET__D$07FJ0K__"